import { useMutation, useQueryClient } from '@tanstack/react-query';
import { licenseDeviceKeys } from '@platform/billing';
import { licenseDeviceApi } from './license-device.api';

/**
 * 본인 기기 해제 — 교체 횟수 1회 차감.
 * 실패(횟수 소진 429 등)는 서버 문구를 전역 알림이 그대로 보여준다.
 */
export function useReleaseMyDevice() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (deviceId: string) => licenseDeviceApi.releaseMine(deviceId),
    // 실패해도 다시 본다 — 다른 탭·PC 에서 먼저 해제됐으면 목록이 낡아 있다.
    onSettled: () =>
      qc.invalidateQueries({ queryKey: licenseDeviceKeys.mine }),
  });
}
